import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'

import { priorities } from '@/utils/constants'


export default /*#__PURE__*/_defineComponent({
  __name: 'PriorityFilter',
  props: {
    selectedPriorities: null,
    dense: { type: Boolean, default: true },
    mandatory: { type: Boolean, default: false }
  },
  emits: ["on-change"],
  setup(__props: any, { emit }: { emit: ((e: 'on-change', priorities: number[]) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { selectedPriorities: number[], dense: boolean, mandatory: boolean }





const selected = computed({
  get() {
    return props.selectedPriorities ?? []
  },
  set(newArray: number[]) {
    emit('on-change', newArray)
  }
})

return { __sfc: true,props, emit, selected, priorities }
}

})